// Pathify
import { make } from 'vuex-pathify'
import { escapeForRequest, importChunk } from '@/util/helpers'

const _ = require('lodash')

const endpoint = 'https://9s2n7lwizd.execute-api.us-east-2.amazonaws.com'
const setIsBusy = 'setIsBusy'

const state = {
  displayAsSingular: 'Assembly',
  displayAsPlural: 'Assemblies',
  assemblies: {
    all: [],
    data: [],
    originalData: [],
    toImport: [],
    isBusy: false,
    isFirst: false,
    isLast: false,
    selected: [],
    selectedItem: { id: '', description: '' },
    setLast: false,
    includeDetails: false,
    empty: {
      id: null,
      assembly_id: null,
      client_id: null,
      plan_id: null,
      phase_id: null,
      description: null,
      pv_id: null,
      note: '',
      days_from_start: null,
      duration: null,
      instructions: '',
      result: null,
      updated: false,
      update_program: null,
      update_user_id: null,
    },
    headers: {
      headerId: {
        text: 'ID',
        align: 'start',
        value: 'id',
        sortable: true,
        filterable: true,
        groupable: false,
        width: '1%',
        class: 'primary--text font-weight-bold',
      },
      headerDescription: {
        text: 'Description',
        align: 'start',
        value: 'description',
        sortable: true,
        filterable: true,
        groupable: false,
        width: '1%',
        class: 'primary--text font-weight-bold',
      },
      headerPromptGroup: {
        text: 'Prompt Group',
        align: 'start',
        value: 'prompt_description',
        sortable: true,
        filterable: true,
        width: '1%',
        class: 'primary--text font-weight-bold text-no-wrap',
      },
    },
    tabbedColumns: {
      id_header: 'Assembly ID',
      description_header: 'Assembly Description',
    },
  },
}

function fetchData (url, options) {
  return new Promise((resolve, reject) => {
    fetch(url, options)
      .then(response => {
        const statusMessage = `${response.status}: "${response.statusText}"`

        if (!response.ok) {
          throw Error(statusMessage)
        }

        return response.json()
      })
      .then(jsonResponse => {
        if (_.isEmpty(jsonResponse.error)) {
          resolve(jsonResponse.data)
        } else {
          reject(jsonResponse.error)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

const mutations = {
  ...make.mutations(state),

  setIsBusy: (state, isBusy) => {
    state.assemblies.isBusy = isBusy
  },

  setIsFirst: (state) => {
    let isFirst = false
    const selectedObject = state.assemblies.selectedItem

    if (selectedObject && {}.hasOwnProperty.call(selectedObject, 'id')) {
      const selectedId = selectedObject.id
      const thisData = state.assemblies.data

      if (thisData && thisData.length > 0) {
        if ({}.hasOwnProperty.call(thisData[0], 'id')) {
          const firstId = thisData[0].id

          if (firstId === selectedId) {
            isFirst = true
          }
        }
      } else {
        isFirst = true
      }
    } else {
      isFirst = true
    }

    state.assemblies.isFirst = isFirst
  },

  setIsLast: (state) => {
    let isLast = false
    const selectedObject = state.assemblies.selectedItem

    if (selectedObject && {}.hasOwnProperty.call(selectedObject, 'id')) {
      const selectedId = selectedObject.id
      const thisData = state.assemblies.data

      if (thisData && thisData.length > 0) {
        if ({}.hasOwnProperty.call(thisData[thisData.length - 1], 'id')) {
          const lastId = thisData[thisData.length - 1].id

          if (lastId === selectedId) {
            isLast = true
          }
        }
      } else {
        isLast = true
      }
    } else {
      isLast = true
    }

    state.assemblies.isLast = isLast
  },

  push2All: (state, dataFromDB) => {
    state.assemblies.all = []

    for (const currentData of dataFromDB) {
      state.assemblies.all.push({ ...currentData })
    }

    state.assemblies.isBusy = false
  },

  push2Data: (state, payload) => {
    state.assemblies.data = []
    state.assemblies.originalData = []

    // Get a copy of the original data, not a pointer to it
    for (const currentData of state.assemblies.all) {
      if (currentData.plan_id === payload.plan_id && currentData.phase_id === payload.phase_id) {
        state.assemblies.data.push({ ...currentData })
        state.assemblies.originalData.push({ ...currentData })
      }
    }

    state.assemblies.selected = []

    state.assemblies.isBusy = false
  },

  push2Import: (state, data2Import) => {
    state.assemblies.toImport = []
    state.assemblies.toImport = data2Import
    state.assemblies.isBusy = false
  },

  importCompleted: (state) => {},
}

const actions = {
  ...make.actions(state),

  init: async () => {
    //
  },

  setEmpty: ({ commit, dispatch }) => {
    state.assemblies.selected = []
    state.assemblies.selectedItem = { id: '', description: '' }
    state.assemblies.data = []
    dispatch('assemblyitem/setEmpty', null, { root: true })
    dispatch('prompt/setEmpty', null, { root: true })
    commit('setIsFirst')
    commit('setIsLast')
  },

  setSelected: async ({ commit, dispatch }, payload) => {
    await dispatch('assemblyitem/setEmpty', null, { root: true })
    await dispatch('prompt/setEmpty', null, { root: true })

    if (payload) {
      state.assemblies.selected = []
      state.assemblies.selectedItem = { ...payload }
      await dispatch('takeoff/retrieve', payload, { root: true })
    } else {
      state.assemblies.selectedItem = { id: '', description: '' }
    }
    await commit('setIsFirst')
    await commit('setIsLast')
  },

  previous: ({ dispatch }) => {
    let previousObject = null
    const selectedId = state.assemblies.selectedItem.id

    for (const existingObject of state.assemblies.data) {
      if (existingObject.id === selectedId) {
        break
      }

      previousObject = { ...existingObject }
    }

    if (previousObject) {
      dispatch('setSelected', previousObject)
    } else {
      dispatch('division/previous', null, { root: true })
    }
  },

  next: ({ dispatch }) => {
    let nextObject = null
    const selectedId = state.assemblies.selectedItem.id

    for (let thisIndex = state.assemblies.data.length - 1; thisIndex >= 0; thisIndex--) {
      const existingObject = state.assemblies.data[thisIndex]

      if (existingObject.id === selectedId) {
        break
      }

      nextObject = { ...existingObject }
    }

    if (nextObject) {
      dispatch('setSelected', nextObject)
    } else {
      dispatch('division/next', null, { root: true })
    }
  },

  // TODO: can retrieveAll be moved to app and used for all modules somehow?
  // TODO: assembly/retrieveAll has been deprecated for retrieveAssembliesByPlans
  retrieveAll: ({ commit, dispatch, rootState }) => {
    if (rootState.customer.customers.selectedItem.client_id.length > 0) {
      const thisAction = 'retrieveAllAssemblies'
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const options = {
        method: 'get',
      }

      fetch(url, options)
        .then(response => {
          const statusMessage = `${response.status}: "${response.statusText}"`

          if (!response.ok) {
            throw Error(statusMessage)
          }

          return response.json()
        })
        .then(jsonResponse => {
          if (_.isEmpty(jsonResponse.error)) {
            commit('push2All', jsonResponse.data)
          } else {
            // toastColor = 'danger'
            // toastMessage = 'was not updated successfully'
            console.error(`${thisAction} failed with url: ${url}`)
            dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
            commit(setIsBusy, false)
          }
        })
        .catch(error => {
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: error }, { root: true })
        })
    }
  },

  retrieve: async ({ commit, dispatch, rootState }, payload) => {
    const thisAction = 'Retrieve Assembly'
    commit(setIsBusy, true)

    try {
      await commit('push2Data', payload)

      // Previous/Next logic
      if (state.assemblies.data.length > 0) {
        if (state.assemblies.setLast) {
          state.assemblies.setLast = false
          dispatch('setSelected', state.assemblies.data[state.assemblies.data.length - 1])
        } else {
          const selectedParent = rootState.division.divisions.selectedItem
          const selectedItem = state.assemblies.selectedItem

          // If we have a selected parent object and selectedItem is empty, select the first data item
          if (selectedParent && {}.hasOwnProperty.call(selectedParent, 'id') && selectedItem && {}.hasOwnProperty.call(selectedItem, 'id')) {
            if (selectedParent.id.trim().length > 0 && selectedItem.id.trim().length <= 0) {
              dispatch('setSelected', state.assemblies.data[0])
            }
          }
        }
      }
    } catch (error) {
      console.error(`${thisAction} failed`)
      commit(setIsBusy, false)
      dispatch('error/setError', { name: thisAction, details: error }, { root: true })
    }
  },

  retrieveAssembliesByPlans: ({ commit, dispatch, rootState }) => {
    if (rootState.customer.customers.selectedItem.client_id.length > 0) {
      const thisAction = 'retrieveAssembliesByPlans'
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const options = {
        method: 'post',
      }

      // Get an even number of records in each chunk
      const numberOfChunks = Math.ceil(rootState.plan.plans.data.length / 50)
      const maxSize = Math.ceil(rootState.plan.plans.data.length / numberOfChunks)
      let chunkSize = 0
      const chunks2Fetch = []
      let plans2Fetch = []

      for (const currentItem of rootState.plan.plans.data) {
        plans2Fetch.push(currentItem.plan_id)
        ++chunkSize

        if (chunkSize >= maxSize) {
          options.body = JSON.stringify({ plans_to_retrieve: plans2Fetch.join(',') })
          chunks2Fetch.push(fetchData(url, options))

          chunkSize = 0
          plans2Fetch = []
        }
      }

      if (chunkSize > 0) {
        options.body = JSON.stringify({ plans_to_retrieve: plans2Fetch.join(',') })
        chunks2Fetch.push(fetchData(url, options))
      }

      // Once all promises are resolved we have a successful import, or display rejected error
      Promise.all(chunks2Fetch)
        .then(responses => {
          const dataFromDB = []

          for (const chunkOfAssemblies of responses) {
            for (const thisAssembly of chunkOfAssemblies) {
              dataFromDB.push(thisAssembly)
            }
          }

          commit('push2All', dataFromDB)
        })
        .catch(error => {
          console.error(`${thisAction} failed for ${state.displayAsSingular}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: error }, { root: true })
        })
    }
  },

  update: ({ commit, dispatch, rootState }, payload) => {
    const thisAction = 'updateAssemblies'
    commit(setIsBusy, true)

    if (payload.plan_id === null) {
      if (payload.id != null) {
        payload.plan_id = payload.id
      }
    }
    payload.assembly_id = payload.id

    const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
    const url = `${actionEndPoint}/${payload.client_id}`

    const options = {
      method: 'post',
      body: JSON.stringify(payload),
    }

    let toastColor = 'success'
    let toastMessage = 'updated successfully'

    fetch(url, options)
      .then(response => {
        const statusMessage = `${response.status}: "${response.statusText}"`

        if (!response.ok) {
          throw Error(statusMessage)
        }

        return response.json()
      })
      .then(jsonResponse => {
        if (_.isEmpty(jsonResponse.error)) {
          // Update selected
          if (state.assemblies.selectedItem && {}.hasOwnProperty.call(state.assemblies.selectedItem, 'id')) {
            if (payload.assembly_id === state.assemblies.selectedItem.id) {
              dispatch('setSelected', payload)
            }
          }

          dispatch('retrieveAssembliesByPlans')
        } else {
          toastColor = 'danger'
          toastMessage = 'was not updated successfully'
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
        }
      })
      .then(() => {
        console.info(`${state.displayAsSingular} Updated - '${payload.description}' ${toastMessage}, variant: ${toastColor}`)
        /*
        dispatch('user/showToast',
          {
            title: `${state.displayAsSingular} Updated`,
            messages: [`'${payload.description}' ${toastMessage}`],
            variant: toastColor,
          },
          { root: true },
        )
         */
      })
      .catch(error => {
        console.error(`${thisAction} failed with url: ${url}`)
        commit(setIsBusy, false)
        dispatch('error/setError', { name: thisAction, details: error }, { root: true })
      })
  },

  delete: ({ commit, dispatch, rootState }) => {
    if (state.assemblies.selected.length > 0) {
      const thisAction = 'deleteAssemblies'
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const options = {
        method: 'post',
        body: JSON.stringify(state.assemblies.selected),
      }

      let toastColor = 'success'
      let toastPrefix = ''
      let toastMessage = 'successfully removed'
      if (state.assemblies.selected.length > 1) {
        toastPrefix = `${state.assemblies.selected.length} ${state.displayAsPlural} were`
      } else {
        toastPrefix = `'${state.assemblies.selected[0].description}'`
      }

      fetch(url, options)
        .then(response => {
          const statusMessage = `${response.status}: "${response.statusText}"`

          if (!response.ok) {
            throw Error(statusMessage)
          }

          return response.json()
        })
        .then(jsonResponse => {
          if (_.isEmpty(jsonResponse.error)) {
            // Remove deleted from selected
            if (state.assemblies.selectedItem && {}.hasOwnProperty.call(state.assemblies.selectedItem, 'id')) {
              for (const currentData of state.assemblies.selected) {
                if (currentData.assembly_id === state.assemblies.selectedItem.id) {
                  dispatch('setSelected', state.assemblies.data[0])
                  break
                }
              }
            }

            dispatch('retrieveAssembliesByPlans')
          } else {
            toastColor = 'danger'
            toastMessage = 'was not deleted successfully'
            console.error(`${thisAction} failed with url: ${url}`)
            commit(setIsBusy, false)
            dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
          }
        })
        .then(() => {
          console.info(`${state.displayAsSingular} Deleted - ${toastPrefix} ${toastMessage}, variant: ${toastColor}`)
          /*
          dispatch('user/showToast',
            {
              title: `${state.displayAsSingular} Deleted`,
              messages: [`'${payload.description}' ${toastMessage}`],
              variant: toastColor,
            },
            { root: true },
          )
          */
        })
        .catch(error => {
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: error }, { root: true })
        })
    }
  },

  duplicate: ({ commit, dispatch, rootState }, payload) => {
    const thisAction = 'duplicateAssembly'
    commit(setIsBusy, true)

    if (payload.plan_id === null) {
      if (payload.id != null) {
        payload.plan_id = payload.id
      }
    }
    payload.assembly_id = payload.id

    const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
    const url = `${actionEndPoint}/${payload.client_id}/${state.assemblies.includeDetails}`

    payload.selected_assembly.description = escapeForRequest(payload.selected_assembly.description.toString())
    payload.description = escapeForRequest(payload.description.toString())
    payload.note = escapeForRequest(payload.note.toString())

    const options = {
      method: 'post',
      body: JSON.stringify(payload),
    }

    let toastColor = 'success'
    let toastMessage = 'duplicated successfully'

    fetch(url, options)
      .then(response => {
        const statusMessage = `${response.status}: "${response.statusText}"`

        if (!response.ok) {
          throw Error(statusMessage)
        }

        return response.json()
      })
      .then(jsonResponse => {
        if (_.isEmpty(jsonResponse.error)) {
          dispatch('retrieveAssembliesByPlans')
        } else {
          toastColor = 'danger'
          toastMessage = 'was not updated successfully'
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
        }
      })
      .then(() => {
        const messageTitle = `${state.displayAsSingular} Duplicated`
        const fullMessage = `'${payload.description}' ${toastMessage}`
        console.info(`${messageTitle} - ${fullMessage}, variant: ${toastColor}`)

        dispatch('user/showToast',
          {
            title: messageTitle,
            messages: [fullMessage],
            variant: toastColor,
          },
          { root: true },
        )
      })
      .catch(error => {
        console.error(`${thisAction} failed with url: ${url}`)
        commit(setIsBusy, false)
        dispatch('error/setError', { name: thisAction, details: error }, { root: true })
      })
  },

  importAll: async ({ commit, dispatch, rootState, state }, payload) => {
    const thisAction = 'updateAssemblies'

    if (rootState.customer.customers.selectedItem.client_id.length > 0 && payload.length > 0) {
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const emptyItem = { ...state.assemblies.empty }
      dispatch('user/setStateAsUpdated', emptyItem, { root: true })

      // Get an even number of records in each chunk
      const numberOfChunks = Math.ceil(payload.length / 100)
      const maxSize = Math.ceil(payload.length / numberOfChunks)
      let chunkSize = 0
      const chunks2Import = []
      let totalAttempted = 0
      let items2Import = []
      let item2Import = {}

      for (const currentItem of payload) {
        // Ensure we have all required data and the proper selected client
        item2Import = { ...emptyItem }

        item2Import.id = currentItem.id
        item2Import.assembly_id = currentItem.id
        item2Import.phase_id = currentItem.phase_id
        item2Import.plan_id = currentItem.plan_id
        item2Import.description = currentItem.description
        item2Import.pv_id = currentItem.pv_id

        items2Import.push(item2Import)
        ++chunkSize

        if (chunkSize >= maxSize) {
          chunks2Import.push(importChunk(state.displayAsPlural, url, [...items2Import]))

          totalAttempted += chunkSize
          chunkSize = 0
          items2Import = []
        }
      }

      if (chunkSize > 0) {
        chunks2Import.push(importChunk(state.displayAsPlural, url, [...items2Import]))
        totalAttempted += chunkSize
      }

      let toastColor = 'success'
      let toastMessage = 'imported successfully'

      if (chunks2Import.length > 0) {
        // Once all promises are resolved we have a successful import, or display rejected error
        Promise.all(chunks2Import)
          .then(responses => {
            dispatch('importData/setImportCount', { sheetName: state.displayAsPlural, importCount: totalAttempted }, { root: true })
            dispatch('importData/setSelectedIsComplete', state.displayAsPlural, { root: true })
            commit('importCompleted')
            dispatch('retrieveAssembliesByPlans')

            for (const thisResponse of responses) {
              if (_.isEmpty(thisResponse.error)) {
                console.info(`${thisResponse.details} { ${toastMessage}, variant: ${toastColor} }`)
              } else {
                toastColor = 'danger'
                toastMessage = 'were not imported successfully'
                console.error(`${thisAction} failed: items ${toastMessage}, variant: ${toastColor}`, responses)
                commit(setIsBusy, false)
                dispatch('importData/setIsBusy', false, { root: true })
                dispatch('error/setError', thisResponse, { root: true })
                break
              }
            }
          })
          .catch(error => {
            console.error(`${thisAction} failed for ${state.displayAsSingular}`)
            commit(setIsBusy, false)
            dispatch('importData/setIsBusy', false, { root: true })
            dispatch('error/setError', { name: thisAction, details: error }, { root: true })
          })
      } else {
        console.error(`${thisAction} failed for ${state.displayAsSingular} due to empty chunks`)
        commit(setIsBusy, false)
        dispatch('importData/setIsBusy', false, { root: true })

        toastColor = 'warning'

        dispatch('user/showToast',
          {
            title: `Import ${state.displayAsPlural}`,
            messages: [`No ${state.displayAsPlural.toLowerCase()} were imported`],
            variant: toastColor,
          },
          { root: true },
        )
      }
    } // client_id & payload length > 0
  },

  push2Import: ({ commit, dispatch, rootState }, payload) => {
    const thisAction = `Push ${state.displayAsPlural} to Import`

    if (payload && {}.hasOwnProperty.call(payload, 'sheetData')) {
      if (rootState.customer.customers.selectedItem.client_id.length > 0 && payload.sheetData.length > 0) {
        commit(setIsBusy, true)

        const emptyItem = { id: null, assembly_id: null, phase_id: null, plan_id: null, description: null, pv_id: null, note: '' }
        const items2Import = []
        let item2Import = {}

        for (const currentItem of payload.sheetData) {
          item2Import = { ...emptyItem }

          item2Import.id = currentItem[state.assemblies.tabbedColumns.id_header]
          item2Import.assembly_id = currentItem[state.assemblies.tabbedColumns.id_header]
          item2Import.phase_id = currentItem[rootState.division.divisions.tabbedColumns.id_header]
          item2Import.plan_id = currentItem[rootState.plan.plans.tabbedColumns.id_header]
          item2Import.description = currentItem[state.assemblies.tabbedColumns.description_header]
          item2Import.pv_id = currentItem[rootState.promptgroup.promptGroups.tabbedColumns.id_header]

          items2Import.push(item2Import)
        }

        dispatch('importData/setRows', { sheetName: state.displayAsPlural, sheetRows: items2Import.length }, { root: true })
        commit('push2Import', items2Import)
      }
    }
  },

  executeImport: ({ dispatch }) => {
    dispatch('importAll', state.assemblies.toImport)
  },
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
